import React, { ReactElement } from 'react'
import {
    StyledPaginationItem,
    StyledPaginationLink,
    StyledText,
} from '../Pagination.styled'
import { DisplayProperty } from 'csstype'
import { BreakpointState, ThemeConfig } from '../../../__styling'

export type DisplayProps = BreakpointState<
    ThemeConfig,
    {
        display: DisplayProperty
    }
>
export type PaginationItemProps = {
    text?: string
    isDisabled: boolean
    layout: {
        showText: boolean
        hideTextAtMobile?: boolean
        display: DisplayProps
    }
    onClick: (e: number) => void
    routePath: string
    page: {
        currentPage: number
        nextPage: number
    }
    icon?: {
        iconElement: ReactElement
        iconPosition: 'before' | 'after'
    }
}

export const PaginationItem = ({
    text,
    isDisabled,
    layout,
    onClick,
    routePath,
    page,
    icon,
}: PaginationItemProps) => {
    const isCurrentPage = page.currentPage === page.nextPage
    const route =
        page.nextPage === 1
            ? `${routePath}`
            : `${routePath}?page=${page.nextPage}`
    const ariaCurrent = isCurrentPage ? 'page' : undefined
    const ariaLabel = `Goto Page ${text ? text : page.nextPage}`
    const tabIndex = isDisabled ? -1 : undefined

    const content = (
        <>
            {icon?.iconPosition === 'before' && icon.iconElement}
            <StyledText hideTextAtMobile={layout.hideTextAtMobile}>
                {layout.showText ? (text ? text : page.nextPage) : null}
            </StyledText>
            {icon?.iconPosition === 'after' && icon.iconElement}
        </>
    )
    return (
        <>
            {isDisabled ? (
                <li aria-hidden="true">
                    <StyledPaginationItem
                        display={layout.display}
                        tabIndex={tabIndex}
                        onClick={() => onClick(page.nextPage)}
                        hasIcon={icon !== undefined}
                        className="disabled"
                    >
                        {content}
                    </StyledPaginationItem>
                </li>
            ) : (
                <li aria-label={ariaLabel} aria-current={ariaCurrent}>
                    <StyledPaginationLink
                        to={route}
                        display={layout.display}
                        onClick={() => onClick(page.nextPage)}
                        hasIcon={icon !== undefined}
                        className={isCurrentPage ? 'enabled-active' : 'enabled'}
                    >
                        {content}
                    </StyledPaginationLink>
                </li>
            )}
        </>
    )
}
